module.exports = __webpack_public_path__ + "static/media/logo-gob-yaracuy-nuevo.21c6e9c3.png";